import styled, { css } from "styled-components";

const dragActive = css`
  border-color: #78e5d5;
`;

const dragReject = css`
  border-color: #e57878;
`;

export const DropContainer = styled.div.attrs({
  className: "dropzone"
})`
  margin: 10px 0;
  border: 2px dashed lightblue;
  border-radius: 4px;
  cursor:  ${props => props.disabled ? 'auto' : 'pointer'}
  opacity: ${props => props.disabled ? '0.3' : '1'}
  transition: height 0.2s ease;

  ${props => props.isDragActive && dragActive};
  ${props => props.isDragReject && dragReject};
`;

const messageColors = {
  default: "#999",
  error: "#e57878",
  success: "#78e5d5"
};

export const UploadMessage = styled.span`
  display: flex;
  color: ${props => messageColors[props.type || "default"]};
  justify-content: center;
  align-items: center;
  padding: 15px 0 0 0;
  margin: 15px 0 0 0;

`;

export const UploadMessageUnder = styled.span`
  display: flex;
  color: ${props => messageColors[props.type || "default"]};
  justify-content: center;
  align-items: center;
  padding: 0 0 15px 0;
  margin: 0 0 15px 0;
`;
